import styled from "@emotion/styled";

export const Section = styled.section<{ blue?: boolean }>`
  position: relative;
`;

export const Header = styled.header`
  background-color: #2f8de4;
  position: relative;
  h2 {
    color: #fff;
  }
  span {
    margin-top: 10px;
    display: block;
    font-weight: 500;
  }
`;

export const Thumbnail = styled.img`
  position: relative;
  width: 100%;
  border-radius: 1.25rem;
  margin-top: 2rem;
  z-index: 10;
`;

export const Container = styled.div`
  max-width: 60.125rem;
  margin: 0 auto;
  padding: 4.6875rem 1.25rem;
  padding-top: 150px;
  @media (max-width: 767px) {
    padding: 4rem 1.25rem;
  }
`;

export const Wrapper = styled.div<{ top: boolean }>`
  @media (max-width: 767px) {
    margin-top: ${(props) => (props.top ? "3.125rem" : "1rem")};
    margin-bottom: 3.125rem;
  }
`;

export const Body = styled.div`
  position: relative;
  background-color: #f8f9fa;
  margin-top: -152px;
  z-index: 5;
`;

export const Separator = styled.img`
  position: absolute;
  bottom: 150px;
  left: 0px;
  right: 0px;
  width: 100%;
  z-index: 1;
  transform: rotate(180deg);
`;

export const ContentWrapper = styled.div`
  font-family: "Poppins", sans-serif;
  color: grey !important;
  margin-top: 2rem;
  iframe.ql-video {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }

  p,
  li {
    color: grey !important;
    font-size: 16px !important;
    line-height: 1.85;
  }

  a {
    font-weight: 700;
    color: #2f8de4 !important;
  }

  h2 {
    font-weight: 800;
    font-size: 1.5rem;
    color: #3b3b3b;
    margin-top: 3rem;
  }
`;

export const WrittenByWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1.5rem;
`;

export const UserThumbnail = styled.img`
  width: 50px;
  border-radius: 10px;
`;

export const UserDetails = styled.div``;

export const UserName = styled.span`
  color: #3b3b3b;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  display: block;
`;

export const UserRole = styled.span`
  color: grey;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  display: block;
`;
